import classNames from 'classnames';
import Preact from 'preact';
import { SiteMapItem } from '../../content';
import testId from '../../helpers/testId';

interface Props {
  footerMenu: SiteMapItem[];
}

const FooterText: Preact.FunctionalComponent<Props> = ({ footerMenu }) => (
  <div className="container">
    <div className="row jg-space-phxs@md">
      {footerMenu.map((menuItem, idx) => {
        const key = `menu_${idx}`;
        return (
          <section
            key={key}
            className={classNames(
              testId('footer-text__group'),
              'col-lg-6 col-xl-3 jg-space-mbsm',
              'jg-space-mtml jg-space-mtlg@xl',
            )}
          >
            <h2
              className={classNames(
                testId('footer-text__group__title'),
                'jg-space-mbmd',
                'jg-h5'
              )}
            >
              {menuItem.title}
            </h2>
            <ul className="jg-list--unstyled">
              {menuItem.links.map((item, itemIdx) => (
                <li key={itemIdx}>
                  <a
                    className={classNames(
                      testId('footer-text__group__link'),
                      'jg-text--regular jg-display-b jg-space-pvxs',
                      'jg-color--empress jg-color--nero@hover jg-text-no-underline@hover',
                    )}
                    href={item.url}
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </section>
        );
      })}
    </div>
  </div>
);

export default FooterText;
